import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule } from '@angular/material/dialog';

@Component
({
    selector: 'confirm-dialog',
    templateUrl: './confirmDialog.component.html',
    styleUrls: ['./confirmDialog.component.scss'],
    standalone: true,
    imports: [MatButtonModule, MatDialogModule]
})
class ConfirmDialogComponent
{
    constructor
    (
        public dialogRef: MatDialogRef<ConfirmDialogComponent>,
        @Inject(MAT_DIALOG_DATA) public data: { title: string; message: string }
    )
    {}

    onNoClick(): void
    {
        this.dialogRef.close(false);
    }
}

export { ConfirmDialogComponent }
